/**
 * Modelo de la publicación de un documento
 *
 * @export
 * @class Publicacion
 */

import { Documento } from "./documento.model";

export class Boletines {
  id?: number;
  codigo: string;
  mes: number;
  mes_letras?: string;
  ano: number;
  mostrar?: string;
}

export class Publicacion {
  id: number;
  documento: Documento;
  fecha_publicacion: Date;
  publicado: boolean;
  boletín: Boletines;
  asunto?: string;
  estado?: string;
  consecutivo_boletin?: string;
  radicado?: string;
}






// WEBPACK FOOTER //
// ./src/app/shared/models/publicacion.model.ts